import { authServiceAxiosClient } from '@/lib';
import { AppError, withLogger } from '@/utils';

import { userSettingsAPIUrls } from '../data';
import { UserDetails } from '../types';

type Licence = {
  id: string;
  tier_id: string;
  has_access: boolean;
};

type CreateUserParams = {
  email: string;
  first_name: string;
  last_name: string;
  position: string;
  admin: string;
  tfa_enable: string;
  licences: Licence[];
};

type Response = {
  success: boolean;
  message: string;
  data: UserDetails;
};

type Return = UserDetails;

export type CreateUser = {
  param: CreateUserParams;
  return: Return;
};

export const createUser = withLogger(
  async (params: CreateUserParams): Promise<Return> => {
    if (
      !params.email ||
      !params.first_name ||
      !params.last_name ||
      !params.position ||
      !params.admin ||
      !params.tfa_enable ||
      !params.licences
    ) {
      throw new AppError({
        type: 'user-creation',
        message: 'Missing required user details.',
      });
    }

    const url = userSettingsAPIUrls.save;

    const {
      data: { data },
    } = await authServiceAxiosClient.post<Response>(url, params);

    return data;
  },
);
